import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { BeneficialOwnerService } from 'src/app/services/beneficial-owner.service';
@Component({
  selector: 'app-ben3list',
  templateUrl: './ben3list.component.html',
  styleUrls: ['./ben3list.component.css']
})
export class Ben3listComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL: any;
  response: boolean;
  deleteBen3Id: any;
  nameOfOwner: String;
  dateOfEntry: any;
  dateOfFillingBen: any;
  editBenID: any;
  dateOfCessation: any;
  dateofdeclarationundersection90: any;
  isSearchDivVisible = false;


  constructor(private beneficialOwner: BeneficialOwnerService, private router: Router, private commonFunction: CommonFunction,
    private alert: AlertComponent,private route: ActivatedRoute) {
    this.response = false;
  }

  ngOnInit() {

    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [9] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Particulars of the beneficial owner holding significant beneficial interest',
          title: 'Particulars of the beneficial owner holding significant beneficial interest',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 4, 6, 8],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.getRegisterDirectorList();

    this.currentURL = window.location.href;
    var haseditpermisssion: any = false;
    if (this.currentURL.includes('edit') && !environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'edit');
    }
    else if (environment.PSS) {
      haseditpermisssion = this.commonFunction.validateURL('Director', 'add');
    }
    haseditpermisssion = false;

  }

  addBeneficial(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['beneficial-owner','add']  } }],
      { relativeTo: this.route.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  adjustdirectormasterTable() {
    var directorData = this.registerDirectorList;
    if (directorData.length) {
      this.registerDirectorList = [];
      $("#ben3ListTable").DataTable().destroy();
      this.registerDirectorList = directorData;
      this.dtTriggerMasterDirector.next();
      setTimeout(() => {
        $("#ben3ListTable").DataTable().columns.adjust().draw();
      }, 200);
    }
  }

  tabRegisterOfDirectorOnClickEvent() {
    setTimeout(() => {
      $("#ben3ListTable").DataTable().columns.adjust().draw();
    });
  }


  getRegisterDirectorList() {

    this.registerDirectorList = [];
    this.beneficialOwner.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      $("#ben3ListTable").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerRegisterDirector.next();
      // }, 200);
    });
  }

  confirmDelete(id) {
    this.deleteBen3Id = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletebeneficialOwnerdetail() {
    this.beneficialOwner.removebeneficialOwnerdetails(this.deleteBen3Id)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#ben3ListTable").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getRegisterDirectorList();

      });

  }

  editbeneficialOwnerdetail(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['beneficial-owner','edit',_id]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['beneficial-owner/edit/', _id]);
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateOfCessation, 
      toDate: this.dateofdeclarationundersection90,
      name: this.nameOfOwner,
      date1: this.dateOfEntry,
      date2: this.dateOfFillingBen
    }
    console.log(object)
    this.beneficialOwner.generatebeneficialOwnerDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.beneficialOwner.downloadbeneficialOwnerFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.beneficialOwner.downloadbeneficialOwnerPdfFile(id, 'Multi');
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfOwner": this.nameOfOwner,
      "dateOfEntry": this.setDate(this.dateOfEntry),
      'dateOfFillingBen': this.setDate(this.dateOfFillingBen),
      'dateOfCessation':this.setDate(this.dateOfCessation),
      'dateofdeclarationundersection90':this.setDate(this.dateofdeclarationundersection90),
      'isSearch': true,
    };

    this.registerDirectorList = [];
    $("#ben3ListTable").DataTable().destroy();
    this.beneficialOwner.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      if (registerList.status == 0) {
        this.registerDirectorList = registerList.data;
        this.dtTriggerRegisterDirector.next();
      }
    });
  }

  clearAdvSearch() {
    this.dateOfEntry = undefined;
    this.dateOfFillingBen = undefined;
    this.dateOfCessation=undefined;
    this.dateofdeclarationundersection90=undefined;
    this.nameOfOwner = '';
    $("#ben3ListTable").DataTable().destroy();
    this.getRegisterDirectorList();
  }
}
